var EHDI = EHDI || Object.create(null);
var WTE = WTE || Object.create(null);


EHDI.scene.GameScene = function() {
    EHDI.aka.Container.call(this);

    EHDI.scene.GameScene.game = new WTE.GameEngine();
    EHDI.scene.GameScene.timer = new EHDI.components.Timer();
        EHDI.scene.GameScene.timer.timeLeft =EHDI.GAME.constants.gametimelimit / 1000;
        EHDI.scene.GameScene.timer.x =  280;
        EHDI.scene.GameScene.timer.y =  5;
    EHDI.GAME.pauseButton = new EHDI.components.pauseButton();

}

EHDI.scene.GameScene.prototype = Object.create(EHDI.aka.Container.prototype);

EHDI.scene.GameScene.prototype.screenWillAppear = function() {
    EHDI.scene.GameScene.game.init();
    this.addChild(EHDI.scene.GameScene.game);
    EHDI.scene.GameScene.scoreHolder = EHDI.components.ScoreManager(this);
        EHDI.scene.GameScene.scoreHolder.setXY(10,5);
    this.addChild( EHDI.scene.GameScene.timer);
    this.addChild(EHDI.GAME.pauseButton);
};

EHDI.scene.GameScene.prototype.screenDidAppear = function() {
    EHDI.DBoneFactory.enableClock = false;  
    
    EHDI.scene.GameScene.game.gameStart();

    if ( EHDI.GAME.saveData.isFirstTimePlay ) {

        EHDI.GAME.saveData.isFirstTimePlay = false; 
        EHDI.GAME.storageManager.setLocalInfo( EHDI.GAME.id, EHDI.GAME.saveData );
        /* EHDI.sbGame.saveGameData(EHDI.GAME.saveData, "DEFAULT", function(){
            console.log("data saved.");
        }); */
        EHDI.GAME.pauseButton.isPaused = true;
        EHDI.GAME.sceneManager.pushPopUp(new EHDI.popup.PausePopUp(), {y : new EHDI.scene.TransitionParameter(-EHDI.GAME.sceneManager.getStageHeight(), EHDI.GAME.sceneManager.getStageHeight() * 0.5), duration : 0.25});
    }
};

EHDI.scene.GameScene.prototype.screenDidDisappear = function() {
    //this.destroy({children: true});
    EHDI.scene.GameScene.game.removeGameLoop();
    EHDI.scene.GameScene.game.killListeners();
    EHDI.scene.GameScene.game.killGraphics();
    EHDI.scene.GameScene.game.killProps();
    EHDI.scene.GameScene.timer.dispose();
    EHDI.scene.GameScene.timer = null;
    dragonBones.WorldClock.clock.clear();
    delete this;
    
      
}

EHDI.scene.GameScene.prototype.replay = function(){
    
    EHDI.scene.GameScene.game.removeGameLoop();
    EHDI.scene.GameScene.timer.dispose();
    EHDI.scene.GameScene.timer = null;
    // delete this;
    dragonBones.WorldClock.clock.clear();
    EHDI.scene.GameScene.game.killListeners();
    EHDI.scene.GameScene.game.killGraphics();
    EHDI.scene.GameScene.game.killProps();

    EHDI.scene.GameScene.game = new WTE.GameEngine();
    EHDI.scene.GameScene.timer = new EHDI.components.Timer();
    EHDI.scene.GameScene.timer.timeLeft =EHDI.GAME.constants.gametimelimit / 1000;
    EHDI.scene.GameScene.timer.x =  280;
    EHDI.scene.GameScene.timer.y =  5;
    EHDI.GAME.pauseButton = new EHDI.components.pauseButton();
    
    EHDI.scene.GameScene.game.init();
    this.addChild(EHDI.scene.GameScene.game);
    EHDI.scene.GameScene.scoreHolder = EHDI.components.ScoreManager(this);
        EHDI.scene.GameScene.scoreHolder.setXY(10,5);
    this.addChild( EHDI.scene.GameScene.timer);
    this.addChild(EHDI.GAME.pauseButton);

    EHDI.DBoneFactory.enableClock = false;  
    
    EHDI.scene.GameScene.game.gameStart();

}

EHDI.scene.GameScene.prototype.dispose = function(){
    EHDI.scene.GameScene.game.removeGameLoop();
    EHDI.scene.GameScene.timer.dispose();
    EHDI.scene.GameScene.timer = null;
    // delete this;
    dragonBones.WorldClock.clock.clear();
    EHDI.scene.GameScene.game.killListeners();
    EHDI.scene.GameScene.game.killGraphics();
    EHDI.scene.GameScene.game.killProps();
}